export default "__VITE_ASSET__CpgeZ6Jc__"